import React from 'react';
import axios from 'axios';
import {BaseModal} from '../comun/Index';

class Nueva extends React.Component {
  constructor(props) {
    super(props);
    this.state={}
    this.archivo = React.createRef();
  }

  componentDidMount(){
    if (this.props.datos !== undefined){
      this.setState(JSON.parse(JSON.stringify(this.props.datos)));
    }
  }

  guardar(){
    var formData = new FormData();
    formData.append("archivo", this.archivo.current.files[0]);
    const url = localStorage.getItem('apiUrl') + '/api/geo/padron/admin/subir';
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'authorization': sessionStorage.getItem('token')
      }
    }
    axios.post(url, formData, config)
    .then((res) => {
      if (res.data.status === 'ok'){
        alert("Archivo subido correctamente");
      } else {
        alert("Ocurrio un error");
        console.log(res.data.error);
      }
    })
    .catch((e) => {
      console.log(e);
      alert("Ocurrio un error");
    })
  }

  render(){
    const {descripcion} = this.state;
    return(
      <BaseModal
        titulo="Datos de Area"
        loading={false}
        botonera={[
          {titulo:"Salir", backgroundColor:'#FF2C00', onClick: () => this.props.salir()},
          {titulo:"Guardar", backgroundColor:'#00B845', onClick: () => this.guardar()}
        ]}
      >
      <input
        style={{margin:5}}
        type="file"
        name="archivo"
        accept=".csv"
        ref={this.archivo}
      />
      </BaseModal>
    );
  }
}

export default Nueva;
